<template>
    <vueper-slides
        ref="vslides"
        class="no-shadow mx-25px"
        :class="{ 'cant-slide': !canSlide }"
        :fixed-height="isRecommended ? '750px' : '600px'"
        :visible-slides="isRecommended ? 5 : 7"
        slide-multiple
        :gap="1"
        :slide-ratio="1 / 4"
        :dragging-distance="200"
        :breakpoints="{
            390: { visibleSlides: 2, slideMultiple: 2, fixedHeight: '500px' },
            450: { visibleSlides: 2, slideMultiple: 2, fixedHeight: '550px' },
            550: { visibleSlides: 2, slideMultiple: 2, fixedHeight: '600px' },
            800: { visibleSlides: 3, slideMultiple: 3, fixedHeight: '600px' },
            1000: { visibleSlides: 4, slideMultiple: 4, fixedHeight: '600px' },
            1300: { visibleSlides: 4, slideMultiple: 4, fixedHeight: '700px' },
            1500: { visibleSlides: 5, slideMultiple: 5, fixedHeight: '650px' }
        }"
        :bullets="false"
        :arrows="true"
        style="margin: 26px"
    >
        <vueper-slide v-for="product in products" :key="product.id" :title="product.name" class="h-470px">
            <template #content>
                <div class="h-100">
                    <product-item :product="product" container-class="h-100" />
                </div>
            </template>
        </vueper-slide>
    </vueper-slides>
</template>

<script>
import { VueperSlides, VueperSlide } from 'vueperslides'
import 'vueperslides/dist/vueperslides.css'
import ProductItem from './products/partials/ProductItem';

export default {
    name: 'MostPopularProducts',
    components: {ProductItem, VueperSlides, VueperSlide },

    props: {
        products: {
            type: Array
        },
        type: {
            type: String,
            default: ''
        }
    },

    computed: {
        isRecommended() {
            return this.type === 'recommended'
        }
    },

    data() {
        return {
            canSlide: true
        }
    },

    updated() {
        this.canSlide = this.$refs.vslides.canSlide
    }
}
</script>

<style lang="scss">
.cant-slide {
  .vueperslides__track-inner {
    justify-content: center;
  }
}
</style>
